import React from 'react';
import { useTranslation } from 'react-i18next';

import NoOrganisationCard from 'components/v2/empty-state/NoOrganisationCard';
import { ReactComponent as DashboardIcon } from 'images/v2/icons/svg/fill/svg/dashboard.svg';

const WelcomeToPortal: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <NoOrganisationCard
      icon={<DashboardIcon />}
      title={t('epdDashboard.userHasNoCompanies.welcomeToPortal')}
      descriptionLines={[
        t('epdDashboard.userHasNoCompanies.startEpdPortalInfo1'),
        t('epdDashboard.userHasNoCompanies.startEpdPortalInfo2'),
      ]}
    />
  );
};

export default WelcomeToPortal;
